import { style } from '@angular/animations';
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable({
  providedIn: 'root'
})
export class CustomDateAdapterService extends NativeDateAdapter {
   override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  }
}


